import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().url(),
});

export type Env = z.infer<typeof envSchema>;

function validateEnv(): Env {
  const result = envSchema.safeParse({
    VITE_API_URL: import.meta.env.VITE_API_URL,
  });

  if (!result.success) {
    console.error('Invalid environment variables:', result.error.format());
    throw new Error('Invalid environment variables');
  }

  return result.data;
}

export const env = validateEnv();
